import { useEffect, useState } from "react";
import { Control, Controller } from "react-hook-form";
import { Checkbox } from "semantic-ui-react";

import { AccessibleDropdown } from "../../../../../../components/global_components/form_components/accessible/AccessibleDropdown";
import classNames from "classnames";
import useNotifyCRMTopics from "../../../../hooks/useNotifyCRMTopics";

export function ControlledTwoWayCommunicationDropdown({
  control,
  name,
  label,
  disabled,
}: {
  control: Control;
  name: string;
  label: string;
  disabled: boolean;
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ value, onChange }) => {
        const { data: classifications } = useNotifyCRMTopics();
        const twoWayCommunicationDropDownOptions =
          classifications?.data
            .map((classification) => {
              return {
                value: classification.classification_id,
                label: classification.classification_text,
              };
            })
            .sort((classificationA, classificationB) => {
              const textA = classificationA.label.toLowerCase();
              const textB = classificationB.label.toLowerCase();
              if (textA > textB) return 1;
              if (textB > textA) return -1;
              return 0;
            }) ?? [];
        const [showInput, setShowInput] = useState(!!value);

        useEffect(() => {
          if (value) {
            setShowInput(true);
          }
        }, [value, setShowInput]);

        return (
          <>
            <div className='tw-space-y-2'>
              <div>
                <Checkbox
                  checked={showInput}
                  name={name}
                  label={label}
                  toggle
                  disabled={disabled}
                  onChange={() => {
                    if (showInput) {
                      onChange(null);
                    }
                    setShowInput((prev) => !prev);
                  }}
                  className='tw-flex tw-items-center'
                />
                <div className='-tw-mt-1 tw-ml-[63px] tw-text-sm tw-text-text-hint'>
                  Add a CRM topic, to allow citizens to reply to this notification with questions.
                </div>
              </div>
              <AccessibleDropdown
                className={classNames({
                  "tw-hidden": !showInput,
                })}
                value={value}
                onChange={(option) => {
                  onChange(option);
                }}
                options={twoWayCommunicationDropDownOptions}
                placeholder='None'
              ></AccessibleDropdown>
            </div>
          </>
        );
      }}
    />
  );
}
